import { render, staticRenderFns } from "./AxShortcutLink.vue?vue&type=template&id=27bdf86d&"
import script from "./AxShortcutLink.vue?vue&type=script&lang=ts&"
export * from "./AxShortcutLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports